// ENG-60 (v1.5.19): what a staff-uploaded task attachment means for the client.
// Files only reach the portal on SENT client tasks — this drives the badge in
// TaskDetailRow so staff stop assuming "attached" means "shared".

export type FirmAttachmentVisibility = "portal-visible" | "unsent-client-task" | "internal";

export function firmAttachmentVisibility(task: {
  is_client_task?: boolean | null;
  sent_at?: string | null;
}): FirmAttachmentVisibility {
  if (task.is_client_task !== true) return "internal";
  return task.sent_at ? "portal-visible" : "unsent-client-task";
}
